module.exports = __webpack_public_path__ + "static/media/www.londonjkl.fi.f5e4989e.jpg";